module.exports = __webpack_public_path__ + "static/media/selv.f643c865.svg";